import axios from "axios";
import { API_BASE } from "../../config/env";
/**APPLICATION START */
export const FETCH_APPLICATIONSTART_FULFILLED = "FETCH_APPLICATIONSTART_FULFILLED";
export const FETCH_APPLICATIONSTART_REJECTED = "FETCH_APPLICATIONSTART_REJECTED";
export const FETCH_APPLICATIONSTART_PENDING = "FETCH_APPLICATIONSTART_PENDING";
export const RESET = "RESET"


export function startApplication(ApplicationType, PatientName, PatientGender, PatientAge, PatientPhone, PatientEmail,ProfessionCode) {

    const token = localStorage.getItem("accessToken")

    


    return (dispatch) => {
        dispatch({
            type: "FETCH_APPLICATIONSTART",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v2/second-opinion/application`,
                data: { ApplicationType, PatientName, PatientGender, PatientAge, PatientPhone, PatientEmail,ProfessionCode },
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning" : "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetApplication() {
    return (dispatch) => {
        dispatch({
            type: "RESET",
        });
    };
}


